'use strict';

var jsxRuntime = require('react/jsx-runtime');

var i=jsxRuntime.jsxs("g",{width:"24",height:"24",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:[jsxRuntime.jsx("rect",{y:"5.19995",width:"24",height:"2.4",fill:"#8A8A8A"}),jsxRuntime.jsx("rect",{y:"10.8",width:"24",height:"2.4",fill:"#8A8A8A"}),jsxRuntime.jsx("rect",{y:"16.4",width:"24",height:"2.4",fill:"#8A8A8A"})]});

exports.IconHamburguerMenu = i;
